const MODAL_SELECTOR = '[data-room-modal]';

/** Keyed by the [data-room-modal] container that callers look a modal up by. */
const modals = new Map();

export const findSectionModal = (name) => document.querySelector(`[data-room-modal="${name}"]`);

export const sectionModalBody = (modal) => modal?.querySelector('[data-room-modal-body]') ?? null;

export const openSectionModal = (modal) => {
  modals.get(modal)?.show();
};

const createModal = (container) => {
  const wrapper = container.querySelector('.ds-modal-wrapper');
  const closeButton = wrapper.querySelector('.ds-modal__close_button');

  const modal = new App.views.shared.modal(wrapper, container.querySelector('.ds-modal-overlay'), {
    onShow: () => closeButton?.focus(),
    // The helper leaves the close button to its caller - the mosaic gallery steps back through history.
    onCloseButtonClick: () => modal.hide(),
  });

  // The helper only wires the close button in the header.
  container.querySelectorAll('.js-room-modal-close').forEach((button) => {
    button.addEventListener('click', () => modal.hide());
  });

  return modal;
};

/**
 * Wires every room page section modal to the shared DS modal helper. The bodies are filled
 * elsewhere - see experiments/tm-8339-room-page-compact.js.
 */
export const initSectionModals = () => {
  document.querySelectorAll(MODAL_SELECTOR).forEach((container) => {
    modals.set(container, createModal(container));
  });

  // The helper has no keyboard handling of its own.
  document.addEventListener('keydown', (event) => {
    const visibleModal = Array.from(modals.values()).find((modal) => modal.isVisible());

    if (event.key === 'Escape' && visibleModal) {
      event.stopPropagation();
      visibleModal.hide();
    }
  });
};
